<script>
import { createWidgetMixin } from 'vue-instantsearch/vue3/es'
import { connectCurrentRefinements } from 'instantsearch.js/es/connectors'

export default {
  name: 'AlgoliaRefinementConnector',
  mixins: [createWidgetMixin({ connector: connectCurrentRefinements })],
  emits: [
    'nb-hits-change', 'page-change', 'filters-applied',
  ],
  computed: {
    filtersApplied() {
      return this.state && this.state.items
    },
  },
  watch: {
    filtersApplied() {
      const isFiltered = this.filtersApplied.length > 0
      this.$emit("filters-applied", isFiltered)
    },
  },
  render() {
    return null
  },
}
</script>
